<template>
  <div>
    <!--    <base-app-top-nav></base-app-top-nav>-->

    <top-nav>
      <template slot="nav">
<!--        {{ isIdle }}-->
        <top-nav-sub></top-nav-sub>
      </template>

      <template slot="content">
        <top-nav-content></top-nav-content>
      </template>

    </top-nav>


    <!--    <base-issue tab-name="KOBE CIRCULAR" component-name="KobeCircular" issue-name="issues"></base-issue>-->


    <!--    <base-app-footer></base-app-footer>-->


  </div>
</template>

<script>
import {AppMixins} from '@/mixins/app.mixins';
import {UacMixins} from '@/mixins/uac.mixins';
import {mapActions, mapGetters} from 'vuex';

import TopNav from '@/components/applayout/TopNav';
import Nav from '@/components/applayout/_sub/Nav';
import Content from '@/components/applayout/_sub/Content';
import {AppService} from '@/service/app.service';
import {AlertService} from '@/service/alert.service';

export default {
  name: 'Main',

  components: {
    'top-nav': TopNav,
    'top-nav-sub': Nav,
    'top-nav-content': Content,
  },

  mixins: [AppMixins, UacMixins],

  data() {
    return {};
  },

  methods: {
    ...mapActions(
        [
          'logoutUser',
        ],
    ),

    // setTimer() {
    //   setInterval(this.thisLogOut, 10000); //1080 * 1000
    // },

    // thisLogOut() {
    //   AlertService.sessionExpireAlert();
    // },

  },

  computed: {
    isIdle() {
      if (this.$store.state.idleVue.isIdle === true) {
        AlertService.sessionExpireAlert();
      }

    },
  },

  mounted() {
    // this.setTimer();
  },

};
</script>

<style scoped>

/*For Footer use*/
.container-fluid {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


</style>
